const CONTEXTS = {
  ranges_page: {
    type: 'ranges_page',
    dynamic: false,
    args: {},
  },
  people_page: {
    type: 'people_page',
    dynamic: false,
    args: {},
  },
  settings_page: {
    type: 'settings_page',
    dynamic: false,
    args: {},
  },
  data_page: {
    type: 'data_page',
    dynamic: false,
    args: {},
  },
  comp_cycle_page: {
    type: 'comp_cycle_page',
    dynamic: false,
    args: {},
  },
} as const;

const ROUTE_PATH_TO_CONTEXT_MAP: Record<string, (typeof CONTEXTS)[keyof typeof CONTEXTS]> = {
  '/ranges': CONTEXTS.ranges_page,
  '/people': CONTEXTS.people_page,
  '/employee-portal': CONTEXTS.people_page,
  '/settings': CONTEXTS.settings_page,
  '/data': CONTEXTS.data_page,
  '/ccpv2': CONTEXTS.comp_cycle_page,
} as const;

const isValidPath = (path: string): path is keyof typeof ROUTE_PATH_TO_CONTEXT_MAP => {
  return path in ROUTE_PATH_TO_CONTEXT_MAP;
};

export const getContextToIncludeByRoutePath = (routePath: string) => {
  for (const path in ROUTE_PATH_TO_CONTEXT_MAP) {
    if (isValidPath(path) && routePath.startsWith(path)) {
      return [ROUTE_PATH_TO_CONTEXT_MAP[path]];
    }
  }
  return [];
};

export const doesPathMatchPattern = (currentPath: string, pattern: string) => {
  if (!pattern) return false;

  if (pattern.endsWith('*')) {
    const prefix = pattern.slice(0, -1);
    return currentPath.startsWith(prefix);
  }

  return currentPath === pattern;
};
